/**
 * Dependency imports
 */
import { useMediaQuery } from '@mantine/hooks';
import { useMantineTheme } from '@mantine/core';

/**
 * Local imports
 */

/**
 * Default export
 */
export const useResponsive = () => {
  const theme = useMantineTheme();

  const isXLarge = useMediaQuery(`(min-width: ${theme.breakpoints.lg})`);
  const isLarge =
    useMediaQuery(`(min-width: ${theme.breakpoints.md})`) && !isXLarge;
  const isMedium =
    useMediaQuery(`(min-width: ${theme.breakpoints.sm})`) &&
    !isLarge &&
    !isXLarge;
  const isSmall =
    useMediaQuery(`(min-width: ${theme.breakpoints.xs})`) &&
    !isMedium &&
    !isLarge &&
    !isXLarge;
  const isXSmall = !isSmall && !isMedium && !isLarge && !isXLarge;

  let screen: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'xs';
  screen = isSmall ? 'sm' : screen;
  screen = isMedium ? 'md' : screen;
  screen = isLarge ? 'lg' : screen;
  screen = isXLarge ? 'xl' : screen;

  const responsive = ({
    xs,
    sm,
    md,
    lg,
    xl,
  }: {
    xs?: any;
    sm?: any;
    md?: any;
    lg?: any;
    xl?: any;
  }) => {
    let value = xs;

    value = isSmall ? sm ?? value : value;
    value = isMedium ? md ?? sm ?? value : value;
    value = isLarge ? lg ?? md ?? sm ?? value : value;
    value = isXLarge ? xl ?? lg ?? md ?? sm ?? value : value;

    return value;
  };

  return {
    responsive,
    screen,
    isXSmall,
    isSmall,
    isMedium,
    isLarge,
    isXLarge,
  };
};
